export const goToMailCommand = "R5yQJe";
export const goToCalendarCommand = "uX84cc";
export const goToPeopleCommand = "LE1rVc";
export const goToTasksCommand = "qyUS2";
export const goToToDoCommand = "KDkHge";
export const goToDevToolsCommand = "wIiz0b";
export const goToEdgeTracingToolsCommand = "ogdjxb";
export const jumpFocus = "CL$_Nd";
export default {goToMailCommand,goToCalendarCommand,goToPeopleCommand,goToTasksCommand,goToToDoCommand,goToDevToolsCommand,goToEdgeTracingToolsCommand,jumpFocus};